
//import grapesjs from "grapesjs";
import "grapesjs/dist/css/grapes.min.css";
import '../css/Contact.css'
import { Deployment, ImageUpload, PageSave, getImageListByPAge, GetSlideList, GetPageByID } from "../db/db";
import { useAlert } from "react-alert";
import {
    React,
    createContext,
    useContext,
    useState,
    Devices, Fonts,
    axios, qs, hekcss,
    ckEditor, editorTool,
    ContacComponent,
    myRuler,
    optionsPanel,
    blockAdvance,
    blocksBasic,
    myExport,
    grapesjs,
    mPlugin,
    mpOptions,
    setDevice

} from './useIndex'


const editorContext = createContext();
const pagesInit = [
    {
        id: 1,
        name: "ilk sayfa",
        component: "Gerek Yok",
        styles: "Artık Gerek Yok",
        subtitle: "Alt Başlık",
        author: "Yazar Felan Filan",
        soundUrl: "Sound.file",
        prev: "Prev Data",
    }
]



const PanelOptions = (editor) => {
    const myAlert = useAlert();
    const pn = editor.Panels;
    const panelViews = pn.addPanel({ id: "options" });
    const rteEl = editor.RichTextEditor.getToolbarEl();
    const order = [0, 1, 2, 3, 14, 15, 9, 10, 11, 12, 13, 5, 6, 7, 8]
    rteEl.id = "IndsignCleaner"
    rteEl.className = "rteTool"
    rteEl.firstChild.childNodes.forEach((child, idx) => {

        child.style.order = order[idx]
        child.style.margin = "8px"

        child.style.border = 0
        switch (child.title) {
            case "Bold":
                child.style.order = 0;
                //child.style.left="5px"
                break
            case "Italic":
                child.style.order = 1;
                //child.style.left="25px"
                break
            case "Underline":
                child.style.order = 2;
                //child.style.left="25px"
                break
            case "Strike-through":
                child.style.order = 3;
                //child.style.left="25px"
                break
            case "Align Left":
                child.style.order = 4;
                //child.style.left="25px"
                break
            case "Align Center":
                child.style.order = 5;
                //child.style.left="25px"
                break
            case "Align Right":
                child.style.order = 6;
                //child.style.left="25px"
                break
            case "Align Justify":
                child.style.order = 7;
                //child.style.left="25px"
                break
            case "Paragraph":
                child.style.order = 8;
                //child.style.left="25px"
                break
            case "Clear Formatting":
                child.style.order = 9;
                //child.style.left="25px"
                break
            case "Font Color":
                child.style.order = 10;
                //child.style.left="25px"
                break
            case "Font Highlight":
                child.style.order = 11;
                //child.style.left="25px"
                break
            case "Font Size":
                child.style.order = 12
                child.style.margin = "5px 0 10px 0 "

                child.style.width = "100px"
                break
            case "Font Name":
                child.style.order = 13
                //child.style.padding="5px"
                child.style.border = 0
                child.style.width = "250px"
                child.style.margin = "25px 0,0,0"
                break
            case "Link":
                child.style.display = "none";
                //child.style.left="25px"
                break

            default:

        }

        //  child.style.padding="5px"
        //  child.style.margin="5px"

    });
    editor.DomComponents.addType("image", {
        //isComponent: el => el.tagName == 'image',
        model: {
            defaults: {

                traits: [
                    {
                        type: "select", // Type of the trait
                        label: "Animasyon", // The label you will see in Settings
                        name: "class", // The name of the attribute/property to use on component
                        options: [
                            { id: "anim", name: "animation1" },
                            { id: "sag_iceri", name: "animation2" },
                        ],
                    },
                ],
            },
        },
    });
    editor.BlockManager.get("image").get("content").style = {
        //'max-width':'375px',
        width: "100%",
    };

    editor.DomComponents.addType("input", {
        isComponent: (el) => el.id == "MailButton",
        model: {
            defaults: {
                traits: [
                    {
                        type: "select", // Type of the trait
                        label: "Mail", // The label you will see in Settings
                        name: "Mail", // The name of the attribute/property to use on component
                        options: [
                            {
                                id: "edergisemerkand@semerkanddergisi.com",
                                name: "edergisemerkand@semerkanddergisi.com",
                            },
                            // { id: 'ismail.yapici@techno-software.com', name: 'ismail.yapici@techno-software.com' },
                            // { id: 'ismail.yapici@semerkand.com', name: 'ismail.yapici@semerkand.com' }
                        ],
                    },
                ],
            },
        },
    });


    editor.DomComponents.addType("wrapper", {
        model: {
            defaults: {
                // ...
                traits: [
                    {
                        name: "width",
                        type: "number",
                        value: 400,
                    },
                    {
                        name: "height",
                        type: "number",
                        value: 900,
                    },
                ],
            },

            init() {



                //   // Also the listener changes from `change:attributes:*` to `change:*`
                this.on("change", (e) => {
                    const dev = editor.Devices.get("Standart");
                    const targetAtt = this.get("traits").target.attributes.attributes;
                    let ControlChange = 0;
                    //console.log(dev.attributes)

                    if (targetAtt.height + "px" != dev.attributes.height) {
                        dev.attributes.height = targetAtt.height + "px";
                        ControlChange = 1;
                        console.log(targetAtt.height, dev.attributes.height);
                    }
                    if (targetAtt.width + "px" != dev.attributes.width) {
                        dev.attributes.width = targetAtt.width + "px";
                        ControlChange = 1;
                    }

                    if (ControlChange == 1) {
                        editor.setDevice("Tablet");
                        editor.setDevice("Standart");
                    }


                });



                // assetManager:{
                //     upload:'http://localhost:5000/api/page/Pages/PageImageUpload',
                //     uploadName:'files'
                // }
            },
        },
    });


    editor.on("component:selected", function (args) {
        if (args.attributes.type != "wrapper") {
            args.set("resizable", true);
        }

    });


    editor.on('asset:upload:start', (e) => {
        console.log("FileUpload Başladı", e)
    });
    editor.on('asset:upload:response', (response) => {
        console.log("uploadend", response)
    });

    pn.removeButton('options', 'export-template');
    pn.addButton("views", [
        {
            id: "Open-PageList",
            className: "fa fa-file-o",
            attributes: { title: "PageList" },
            active: true,
            command: "openPageList",
        },
        {
            id: "Open-MagazineProperties",
            className: "fa fa-video-camera",
            attributes: { title: "Magazine Videos" },
            active: false,
            command: "openMagazineProperties",
        },
        {
            id: "Open-MagazineProperties",
            className: "fa fa-volume-up",
            attributes: { title: "Magazine Sounds" },
            active: false,
            command: "openSounds",
        },
        {
            id: "Open-SosialMadia",
            className: "fas fa-hand-pointer",
            attributes: { title: "Sosial Madia" },
            active: false,
            command: "openSosial",
        }
    ]);
    panelViews.get("buttons").add([
        {
            attributes: {
                title: "Serbest Çalışma Modu",
            },
            context: "toggle-rulers",
            label: `<svg width="18" viewBox="0 0 16 16"><path d="M0 8a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 0 1H.5A.5.5 0 0 1 0 8z"/><path d="M4 3h8a1 1 0 0 1 1 1v2.5h1V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v2.5h1V4a1 1 0 0 1 1-1zM3 9.5H2V12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9.5h-1V12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.5z"/></svg>`,
            command: "ruler-visibility",
            id: "ruler-visibility",
        },
    ]);
    pn.addButton("options", [
        {
            id: "TestButton",
            className: "fa fa-fax",
            command: "TestButton",
            attributes: { title: "TestButton" },
            active: false,
        },

        {
            id: "save-page",
            className: "fa fa-save",
            command: "save-page",
            attributes: { title: "save" },
            active: false,
        },
        {
            id: "deploy-magazine",
            className: "fa fa-file-archive-o",
            command: "deploy-magazine",
            attributes: { title: "Dergiyi Yayınla" },
            active: false,
        },]);

    editor.Commands.add("TestButton", {
        run(editor, sender) {

            let htmlData = editor.getHtml();
            console.log("MyEditor", editor)
            // console.log("ConsoleCıktı",this.document.getElementByName("ImageDiv"))
            //    var DcData= document.getElementsByName("ImageDiv");
            //    console.log("dcdata",DcData)
            //    //[0].innerHTML += "</br><a href='www.google.com.tr'><img < img  src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAAAXNSR0IArs4c6QAAAzdJREFUWEfVmFuoTkEUx3/HNRFySa6JyBtJ4UWhUPKCwgOFEB15QC5FkXINRQhRPCBEkkiRS7mVKJHigXggHqSI3PrXbO3mm/3tmflmP5x5OZ39rbXmt9eeWes/00QLGU0thBMbVP+PBvoHvMAb4BHwt45PP2Ac0Mkz7i/gHvAis7dBDwBLPYPlzW4DU4DvDt+pwHmgfWBcwU4GbsjPBv0GdAgMmJlvALY4fF8CQyNj7geWu0Drfb6yuY4CixxGXwM+ue1+BFicElQvOBG46QA9Acwte8uC35ODrgW2F0zWGbgKjI2ATQq6FVhfAtERuGJ2fghvMtA7AZN3B14DXQJIk4FqTmVTWa03WgMngTkBkDJNCloGGwtZCWgRbCOQlYHasI1CVgqawe6IXJPeBf830Mqx4A8CvYDpnpvhKTDcw/YLMBPYXFBnD2Xaw+71UivDrAkkVJqBNsDpANgyTkFOAh4CagrXgDGW0xLgsKuFSumczQmT3cCqnIRrmwg2D5mxCfaMUWF6dgGYDfx0geqZtKM06StAn9Aegj0FzChLWcHvLsi86RDgj2kO/5/HKvzYHS1IacwHoS8ZC6p5QjMrrTverMlQzhrhHBIgJqs+7dbJEJvRGMgMIArWBdrVlI3nwLMKNpNCrgRUUezRG5hljkgS3J8zAxt0lNGNPU1JUrDVVnlqZMfnwWzYkaaW9jBG70wT0N+aNXrLoS/zBT8VZAacwQryOtDNSvEuk6ga0I+AsmkPwaqF+tbOJ8AIz525F5jngJS7jtlqsTWgnwAp8UbGOmCnEb3zGwlUJaggtxk4rf89wIoGYCvJaB4yz7YJ2BgJmxy0CDLjW5PLdAhzUtAyyAxsGbCvQO8WwScDvWvKmc9V0ADT51U9fEcyUE2oI60Ebj1YXWPqumewL6GxSwqqmFlTcMH2AXRRMSgQsrI6ugA47oA5F9AobPfkGdUEl4FpDtD3gLIaMwpBJQD6xkTMX79Y/pcKXsBnmmPAQhna6knHVt0chw5dfk0A3jocBwIXPY/PeXe1cx1bHrtA9UxiQgcs3/EBuJ+dFguclBB9qXa+QQEtmR+ZfazCD5gvjWmLAf0H/x60K3PaJEQAAAAASUVORK5CYII=' /></a>"

        },
    });

    editor.Commands.add("save-page", {

        async run(editor, sender) {



            const QIssueID = (window.location.search.split("?MID=")[1] != undefined) ? window.location.search.split("?MID=")[1] : window.location.pathname.split('/')[1]

            const PageID = editor.PageID;
            const PageName = editor.PageName;
            const rawData = JSON.stringify(editor.Components.getComponents());
            const rawCss = editor.getCss();
            let htmlData = editor.getHtml();
            let divSlide = "";
            let dotDiv = ""
            const getSlideData = await GetSlideList(PageID).then((response) => {
                const SlideCount = Array.from(response.sonuc).length;


                console.log("slidecount", SlideCount)

                const rda = response.sonuc.map((slider, index) => {
                    const newImagePath = "https://edergipanel.semerkanddijital.com.tr/primemags/" + QIssueID + "/" + slider.imagePath
                    dotDiv += '<span class="dot" onclick="currentSlide(' + (index + 1) + ')"></span>'
                    divSlide += '<div class="mySlides fade"><div class="numbertext"><div class="galeri" >GALERİ</div><div class="slideNumber" >' + (index + 1) + '/' + SlideCount + '</div></div><img src="' + newImagePath + '" style="width:100%"></div>'





                })
                //console.log("DivSliderFelan Filan",divSlide)
                //   const rda=  response.sonuc.map((slider,index)=>{
                //       const newImagePath =""// "@https://panel.edergilik.com/primemags/" + QIssueID+"/"+slider.imagePath
                //       const divSlide = '<div class="mySlides fade"><div class="numbertext"><div class="galeri" >GALERİ</div><div class="slideNumber" >'+index+'</div></div><img src="'+newImagePath+'" style="width:100%"></div>'



                //         return divSlide

                //     })

                return divSlide
            }).catch((err) => { console.log("Slide Listesi Sırasında Hata") })

            //console.log("getSlideData",getSlideData)

            let cssData = rawCss;
            htmlData = htmlData.replaceAll('class="MsoNormal"', "");
            cssData = cssData.replaceAll(
                ".MsoNormal{padding-top:0px;padding-right:10px;padding-bottom:0px;padding-left:10px;}",
                ""
            );
            cssData = cssData.replace(
                "@media (max-width: 400px)",
                "@media (max-width: 812px)"
            );


            const SliderHtml = `<div class="slideshow-container">

 ${getSlideData}  


</div>
<br>


<div style="text-align: center;">
 ${dotDiv}
</div>`
            const indexCss = cssData.indexOf("@media");
            const startCss = cssData.toString().substr(indexCss);
            const pStart = startCss.toString().indexOf("(");
            const pEnd = startCss.toString().indexOf(")");
            const lastCss = startCss.toString().substr(pEnd + 1);
            const newCssData = "@media(min-width:100px)" + lastCss;
            const FullLayout = `<!doctype html>
          <html lang="en">
            <head>
              <meta charset="utf-8">
              <link rel="stylesheet" href="./${PageName}.css">
              <meta name="viewport" content="width=device-width, initial-scale=1" />
              <meta http-equiv="X-UA-Compatible" content="ie=edge" />
              <script src="Js_Libs/libs.js"></script>
              <script src="Js_Libs/Hek_Libs.js"></script>
              <link rel='stylesheet'href='./Js_Libs/Hek.css'>
            </head>
            <body>${htmlData + SliderHtml}</body>
          <html>`;
            //console.log("FullLayout",FullLayout)
            const savePage = PageSave(PageID, htmlData + SliderHtml,
                newCssData, PageName, FullLayout, rawData, rawCss)
                .then((res) => {
                    myAlert.success("Sayfanız Kayıt Edilmiştir")

                }).catch((err) => {
                    myAlert.error("Kayıt Sırasında Hata Oluştu : " + err)
                })


        }

    });
    editor.Commands.add("deploy-magazine", {
        run(editor, sender) {

            const QIssueID = (window.location.search.split("?MID=")[1] != undefined) ? window.location.search.split("?MID=")[1] : window.location.pathname.split('/')[1]


            myAlert.info("Deploy işlemi başladı bir kaç dakika sürebilir")
            Deployment(QIssueID).then((res) => {
                myAlert.success("Deploy İşlemi Tamamlandı")
            })
                .catch((err) => {
                    myAlert.error("Hata Oluştu " + err)
                })

        }
    });
    editor.Commands.add("openPageList", {
        run(editor, sender) {
            const pl = (document.getElementById("PageListOrder").style.display = "block");
            //editor.Panels.getPanel('views-container').set('set',pl)
        },
        stop() {
            console.log("stop devrede");
            document.getElementById("PageListOrder").style.display = "none";
        },
    });
    editor.Commands.add("openMagazineProperties", {
        run(editor, sender) {
            const pl = (document.getElementById("MagazinPropertiesDiv").style.display = "block");
            //editor.Panels.getPanel('views-container').set('set',pl)
        },
        stop() {

            document.getElementById("MagazinPropertiesDiv").style.display = "none";
        },
    });
    editor.Commands.add("openSounds", {
        run(editor, sender) {
            const pl = (document.getElementById("SoundsDiv").style.display = "block");
            //editor.Panels.getPanel('views-container').set('set',pl)
        },
        stop() {

            document.getElementById("SoundsDiv").style.display = "none";
        },
    });
    editor.Commands.add("openSosial", {
        run(editor, sender) {
            const pl = (document.getElementById("SosialDiv").style.display = "block");
            //editor.Panels.getPanel('views-container').set('set',pl)
        },
        stop() {

            document.getElementById("SosialDiv").style.display = "none";
        },
    });



}





const EditorProvider = ({ children }) => {

    const editor = grapesjs.init({

        container: '#gjs',
        fromElement: true,
        noticeOnUnload: 0,
        storageManager: { autoload: 0 },
        height: '1000px',
        width: 'auto',
        forceClass: false,
        pageManager: true,
        protectedCss: Fonts,
        blocks: {},
        plugins: mPlugin,
        pluginsOpts: mpOptions,
        canvas: {},
        cssComposer: {},
        deviceManager: { devices: Devices },
        pageManager: { pages: [{}] },
        modal: {},
        customStyleManager: [{}],
        domComponents: {
            // options
        },
        assetManager: {


            // storageType: '',
            // storeOnChange: true,
            // storeAfterUpload: true,
            //upload: 'http://localhost:5000/api/page/Pages/PageImageUpload',
            //uploadName: 'files',
            uploadFile: function (e) {

                const QIssueID = (window.location.search.split("?MID=")[1] != undefined) ? window.location.search.split("?MID=")[1] : window.location.pathname.split('/')[1]
                const PageID = editor.PageID;
                var files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
                console.log("files", files[0])
                // for (var i in files) {

                ImageUpload(files[0], PageID, QIssueID).then((resData) => {
                    editor.AssetManager.add([{
                        category: 'c1',
                        src: resData,

                    }])
                    console.log("ConsoleData : ", resData)
                })
                //}

            }


        },
    },
    );

    editor.on('load', () => {
        editor.setDevice('Standart');
        editor.on('component:update', (e) => {

            //console.log("evalu", e.attributes.tagName)
            //.components.models.tagName)//[1].attributes.attributes.href)
            if (e.attributes.tagName == "img") {

                // console.log("sleect editor",editor.getSelected())
                //document.getElementById('hasan').href = e.changed.src
                // //console.log("href", e.collection.models.attributes)
                // const myTarget=editor.getSelected()
                //myTarget.setHTML("<br><div>HaBuraya</div>")
                // console.log("mytarget",myTarget)
                // console.log("Component Oluşturuldu", e.changed.src)
                //e.onClick=()=>{alert("test")}
                //  e.attributes.components.parent.opt.collection.models[1].attributes.attributes.html="<div>Tıklandımı<div>"
                //  e.attributes.components.parent.opt.collection.models[1].attributes.attributes.href = e.changed.src
                //  console.log("href", e.attributes.components.parent.opt.collection.models[1].attributes.attributes.html)//.models[1].attributes.attributes.href)
                //console.log("hrefTest", document.getElementById('hasan'))
            }
        });
    })


    //asset uploa yapılacak
    // editor.AssetManager.add([
    //     {
    //         // You can pass any custom property you want
    //         category: 'c1',
    //         src: 'http://placehold.it/350x250/78c5d6/fff/image1.jpg',
    //     }, {
    //         category: 'c1',
    //         src: 'http://placehold.it/350x250/459ba8/fff/image2.jpg',
    //     }, {
    //         category: 'c2',
    //         src: 'http://placehold.it/350x250/79c267/fff/image3.jpg',
    //     }
    //     // ...
    // ]);



    const [pages, setPages] = useState(pagesInit);
    const [myEditor, setMyEditor] = useState(null);
    const [pageSlide, setPageSlide] = useState();
    const [showDetail, setShowDetail] = useState("none");
    const [selectedPageProps, setselectedPageProps] = useState([{

        author: "",
        frontTitle: 0,
        id: 0,
        layout: "",
        name: "",
        no: 0,
        pageStyle: "",
        prev: 0,
        rawCss: "",
        rawData: "",
        showMain: 0,
        soundUrl: "",
        subtitle: "",
        thumbUrl: "",
        soundOwner: "",

    }])
    const [pageDetails, setPageDetails] = useState({
        id: null,
        name: null,
        soundUrl: null,
        subtitle: null,
        author: null,
        prev: 0,
        soundTime: "0",
        QIssueID: 0,
        soundFile: null,
        frontTitle: 0,
        showMain: 0,
        thumbUrl: null,
        shortText: "",
        soundOwner: ""
    });

    const setContent = (rawData, rawCss, PageID, PageName, IssueID) => {
        //setActivePage({ id: PageID, name: PageName })

        // Transform old URLs to new domain
        let transformedRawData = rawData;
        let transformedRawCss = rawCss;
        if (typeof rawData === 'string') {
            transformedRawData = rawData.replace(/panel\.edergilik\.com/g, 'edergipanel.semerkanddijital.com.tr');
        }
        if (typeof rawCss === 'string') {
            transformedRawCss = rawCss.replace(/panel\.edergilik\.com/g, 'edergipanel.semerkanddijital.com.tr');
        }

        editor.Components.setComponents(transformedRawData);
        editor.setStyle(transformedRawCss)
        editor.PageID = PageID
        editor.PageName = PageName
        editor.IssueID = IssueID



    }
    const addImageList = (category, src) => {
        console.log("Src Dosyası Eklendi")
        editor.AssetManager.add({ category: category, src: src })
        editor.AssetManager.render(editor.AssetManager.getAll())
    }




    //Options Panel
    PanelOptions(editor)
    //Options Panel

    const GetSelectedPage = async (PageID) => {


        const PageDetailByID = await GetPageByID(PageID).then((resData) => {

            setShowDetail("block")


            return resData[0]
        })

        const SlideByPage = await GetSlideList(PageID).then((res) => {
            return res
        })
        setselectedPageProps(PageDetailByID)
        setPageSlide(SlideByPage)

    }

    const ReloadSlide = async (PageID) => {
        const SlideByPage = await GetSlideList(PageID).then((res) => {
            return res
        })
        setPageSlide(SlideByPage)
    }


    const MagazineID = (window.location.search.split("?MID=")[1] != undefined) ? window.location.search.split("?MID=")[1] : window.location.pathname.split('/')[1]

    const contextVal = {
        pages,
        setPages,
        myEditor,
        setMyEditor,
        setContent,
        addImageList,
        setPageDetails,
        pageDetails,
        editor,
        MagazineID,
        selectedPageProps,
        setselectedPageProps,
        GetSelectedPage,
        setPageSlide,
        ReloadSlide,
        showDetail,
        setShowDetail,
        pageSlide
    }
    return <editorContext.Provider value={contextVal}>{children}</editorContext.Provider>
}

export const useEditorContext = () => useContext(editorContext);
export default EditorProvider;